import { render } from "./OfficeNotasFiscaisTab.vue?vue&type=template&id=28f2f8e1&scoped=true&ts=true"
import script from "./OfficeNotasFiscaisTab.vue?vue&type=script&lang=ts"
export * from "./OfficeNotasFiscaisTab.vue?vue&type=script&lang=ts"

import "./OfficeNotasFiscaisTab.vue?vue&type=style&index=0&id=28f2f8e1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f2f8e1"]])

export default __exports__